import Vue from "vue";
import VueRouter from "vue-router";
import Layout from '../Layout'

const routes = [
    {
        path: '/redirect',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/redirect/:path(.*)',
                component: () => import('@/pages/redirect')
            }
        ]
    },
    {
        path: '',
        component: Layout,
        redirect: 'index',
        children: [
            // {
            //     path: 'index',
            //     component: () => import('@/pages/index/index'),
            //     name: 'Index',
            //     meta: { title: '首页', affix: true }
            // }
            {
                path: 'index',
                component: () => import('@/pages/summary/index'),
                name: 'Index',
                meta: { title: '首页', affix: true }
            }
        ]
    },
    {
        path: '/merchant',
        component: Layout,
        redirect: 'index',
        children: [
            {
                path: '',
                component: () => import('@/pages/merchant/index'),
                name: 'Merchant',
                meta: { title: '商家合作', affix: true }
            }
        ]
    },
    {
        path: '/about',
        component: Layout,
        // redirect: 'noredirect',
        children: [
            {
                path: '',
                component: () => import('@/pages/about/index'),
                name: 'About',
                meta: { title: '关于我们', affix: true }
            }
        ]
    },
    // ...Error
];

// 注册路由
Vue.use(VueRouter);

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
let routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}

const router = new VueRouter({
    mode: "history",
    routes
    //启用html5 history模式的时候生效，用于后退操作的时候记住之前的滚动条位置
    // saveScrollPosition: true
});

// 页面跳转后回到顶部
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
});

// 修改title
function changeTitle(newTitle) {
    let title = "";
    if (newTitle) {
        title = newTitle;
    }
    document.title = title;
}

export { routes };
export default router;
